import {
  Box,
  Button,
  Grid,
  InputLabel,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import FormikControl from 'components/wrapperComponents/FormikControl'; // Adjust the path based on your project structure
import { msgTypes } from 'constants/msgTypes';
import { Field, Form, Formik } from 'formik';
import { MembershipModel } from 'model/screensModels/membership/MembershipModel';
import { useEffect, useRef, useState } from 'react';
import RECAPTCHA from "react-google-recaptcha";
import { useLocation, useNavigate } from 'react-router-dom';
import MembershipFormSchema from 'schemas/menu/membershipForm/MembershipFormSchema';
import { LocalStorageService } from 'services/auth/LocalStorageService';
import { CompanyServicesService } from 'services/menu/companyServicesService/CompanyServicesService';
import { MembershipService } from 'services/menu/membership/MembershipService';
import showAlert from 'services/shared/alert';
import { UtilService } from 'services/shared/UtilService';
import MembershipContactPerson from './MembershipContactPerson';
import ReactQuill from "react-quill";

const UpdateRegisteredMember = ({ setFlag, updateRecord }) => {
 
  const { state } = useLocation();
  const [captchaMatched, setCaptchaMatched] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [initialValues, setInitialValues] = useState(new MembershipModel());
  const [memberDetails, setMemberDetails] = useState(new MembershipModel());
  const [memberlist, setMemberList] = useState([]);
  const [companyServiceList, setCompanyServiceList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const recaptcha = useRef();
  const validation = MembershipFormSchema
  const formikRef = useRef(null);
  const navigate = useNavigate();
  const addBranch = state !== null ? state.addBranch : false;
  const updateCompanyId = state !== null ? state?.companyId : '';
  const [disabledField, setDisabledField] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const isQuillEmpty = (html: string) => {
    const plainText = html?.replace(/<(.|\n)*?>/g, '').trim();
    return plainText === '';
  };



  useEffect(() => {
    loadInitialData();
    getRole();
  }, [])

  //if User came to add branch then All fields are active other wise selected field are active
  useEffect(() => {
    if (addBranch === true || isAdmin === true) {
      setDisabledField(false)
    } else {
      setDisabledField(true)
    }
  }, [addBranch, isAdmin])

  const loadInitialData = async () => {
    await loadCountry();
    await getCompanyServiceList();
    getCompanyDetails();
  }

  useEffect(() => {
    loadFormData();
  }, [memberDetails])

  useEffect(() => {
    if (updateRecord) {
      loadFormData();
    }
  }, [updateRecord])

  const getRole = async () => {
    const role = await LocalStorageService.getUserRole();
    if (role === msgTypes.USER_TYPE.ADMIN) {
      setIsAdmin(true)
    } else {
      setIsAdmin(false);
    }

  }

  // const getCompanyDetails = async () => {
  //   // updateRecord Blank means user want to update
  //   //Take data from local
  //   if (updateRecord === '') {
  //     //add branch false means user want to update profile details either own details or branch details
  //     if (addBranch === false) {
  //       if (updateCompanyId !== null && updateCompanyId !== undefined) {
  //         const requestData = new MembershipModel();
  //         requestData.companyId = updateCompanyId;
  //         const res = await UtilService.getCompanyDetailsByCompanyId(requestData);
  //         if (res.statusMsg === msgTypes.SUCCESS.msg) {
  //           setMemberDetails(res.data);
  //         }
  //       }

  //     }
  //   }
  // }
  const getCompanyDetails = async () => {
    if (updateRecord === '') {
      if (addBranch === false) {
        // ✅ 1. Use companyData directly if passed via state
        if (state?.companyData) {
          setMemberDetails(state.companyData);
          return; // Skip API call
        }

        // ✅ 2. Else fallback to API
        if (updateCompanyId) {
          const requestData = new MembershipModel();
          requestData.companyId = updateCompanyId;
          const res = await UtilService.getCompanyDetailsByCompanyId(requestData);
                   if (res.statusMsg === msgTypes.SUCCESS.msg) {
            setMemberDetails(res.data);
          }
        }
      }
    }
  };

  const loadFormData = async () => {
    // If updateRecord is "" means came from member otherwise from admin
    var receivedMemberDetails = new MembershipModel();
    if (updateRecord === '' || updateRecord === undefined) {
      receivedMemberDetails = memberDetails;
    } else {
      receivedMemberDetails = updateRecord;
    }

    if (receivedMemberDetails.countryId) {
      await loadStateList(receivedMemberDetails.countryId);
      await loadCityList(receivedMemberDetails.stateId)
    }
    receivedMemberDetails.companyServices = receivedMemberDetails?.companyServices?.map(data => { return "" + data })
    receivedMemberDetails.contactPerson = receivedMemberDetails.contactPerson || [];
    setInitialValues(receivedMemberDetails);
    setMemberList(receivedMemberDetails.contactPerson)
  }

  const getCompanyServiceList = async () => {
    const res = await CompanyServicesService.getAllCompanyServicesList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setCompanyServiceList(res.data)
      }
    }

  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    // navigate('/registered-member-list');
  };

  //load country
  const loadCountry = async () => {
    const res = await UtilService.getCountryList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCountryList(res.data);
    }
  }

  //load state list
  const loadStateList = async (countryId) => {
    const requestData = { "country": countryId };
    const res = await UtilService.getStateList(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setStateList(res.data);
    }
  }

  //load City list
  const loadCityList = async (stateId) => {
    const requestData = { "state": stateId };
    const res = await UtilService.getCityList(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCityList(res.data);
    }
  }



  const onCaptchaSubmit = (value) => {
    if (value)
      setCaptchaMatched(true)
    else
      setCaptchaMatched(false)
  }

  const prepareRequestBody = async (values: MembershipModel) => {
    const prepareData = new MembershipModel();

    //to assing id based on action
    if ((initialValues.companyId)?.length > 0) {
      prepareData.companyId = initialValues.companyId;
    } else {
      prepareData.companyId = values.companyId ? values.companyId : '';
    }

    // memberlist.map(data => {
    //   prepareData.contactPerson.push(data);
    // })
    prepareData.contactPerson = [...memberlist];


    prepareData.companyName = values.companyName ? values.companyName : "";
    prepareData.companyEmail = values.companyEmail ? values.companyEmail : "";
    prepareData.primaryPhoneNumber = values.primaryPhoneNumber ? values.primaryPhoneNumber : "";
    prepareData.secondaryPhoneNumber = values.secondaryPhoneNumber ? values.secondaryPhoneNumber : "";
    prepareData.websiteUrl = values.websiteUrl ? values.websiteUrl : "";
    prepareData.accountingEmail = values.accountingEmail ? values.accountingEmail : "";
    prepareData.companyDetails = values.companyDetails ? values.companyDetails : "";
    prepareData.instagramUrl = values.instagramUrl ? values.instagramUrl : "";
    prepareData.linkedinUrl = values.linkedinUrl ? values.linkedinUrl : "";
    prepareData.twitterUrl = values.twitterUrl ? values.twitterUrl : "";
    prepareData.facebookUrl = values.facebookUrl ? values.facebookUrl : "";
    prepareData.youtubeUrl = values.youtubeUrl ? values.youtubeUrl : "";
    prepareData.membershipType = values.membershipType ? values.membershipType : "";
    prepareData.companyLogo = values.companyLogo ? values.companyLogo : "";
    prepareData.status = values.status ? values.status : "";

    prepareData.countryId = values.countryId ? values.countryId : null;
    prepareData.stateId = values.stateId ? values.stateId : null;
    prepareData.cityId = values.cityId ? values.cityId : null;
    prepareData.addressLine1 = values.addressLine1 ? values.addressLine1 : "";
    prepareData.addressLine2 = values.addressLine2 ? values.addressLine2 : "";
    prepareData.zipCode = values.zipCode ? values.zipCode : "";
    prepareData.companyServices = values.companyServices ? values.companyServices : [];
    return prepareData
  }

  const submitMembership = async (values) => {
    // console.log("FINAL SUBMIT values:", values);
  // console.log("FINAL memberlist:", memberlist);
    const requestBody = await prepareRequestBody(values);
    //add branch false means try to update profile either branch or headoffice
    if (addBranch === false) {
      const res = await MembershipService.addMembership(requestBody)
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        setActiveStep(0);
        // setMemberList([]);
        if (updateRecord === '' || updateRecord === undefined) {
          //local storage user details uploaded only when login user change our own details for that get the localstorage companyid and match with updateed id
          //if matched then only update local storage data
          const companyDetails = await LocalStorageService.getUserDetails();
          if (companyDetails !== undefined && companyDetails !== '') {
            const userDetails = JSON.parse(companyDetails);
            if (userDetails.companyId === requestBody.companyId) {
              LocalStorageService.setUserDetails(JSON.stringify(requestBody));
            }
          }
        }

        // if(requestBody.)
        //navigate(RouteType.HOME + RouteType.COMPANY_PROFILE);
        setActiveStep(5);
        // setFlag(false)
        return true
      }
      return false;
    } else {
      const res = await MembershipService.addBranch(requestBody)
      // console.log("Add Branch is ", res)
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        setActiveStep(0);
        setMemberList([]);
        //navigate(RouteType.HOME + RouteType.COMPANY_PROFILE);
        setActiveStep(5);
        // navigate(-1)
        // setFlag(false)
        return true
      }
      return false;
    }
  }

  // const validateContactPersonForm = (values: MembershipModel) => {
  //   const contactPerson = values.contactPerson;
  //   if (contactPerson.length <= 5) {
  //     const representative = contactPerson.filter(data => {
  //       return data.contactIsrepresentative === true;
  //     })
  //     if (representative.length > 1) {
  //       showAlert("Only one representative allowed.", "", msgTypes.error, msgTypes.OK_KEY);
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   } else {
  //     showAlert("Maximum 5 contact person allowed.", "", msgTypes.error, msgTypes.OK_KEY);
  //     return false;
  //   }
  // }

  // OLD:
  // const validateContactPersonForm = (values: MembershipModel) => {
  //   const contactPerson = values.contactPerson || [];

  const validateContactPersonForm = () => {
    const contactPerson = memberlist || [];
    if (contactPerson.length > 10) {
      showAlert("Maximum 10 contact person allowed.", "", msgTypes.error, msgTypes.OK_KEY);
      return false;
    }

    const representative = contactPerson.filter((data: any) => {
      const rep = data?.contactIsrepresentative;
      return rep === true ||
        String(rep).trim().toLowerCase() === "true" ||
        String(rep).trim().toLowerCase() === "yes";
    });

    if (representative.length > 1) {
      showAlert("Only one representative allowed.", "", msgTypes.error, msgTypes.OK_KEY);
      return false;
    }

    if (representative.length === 0) {
      showAlert("At least one representative required.", "", msgTypes.error, msgTypes.OK_KEY);
      return false;
    }

    return true;
  };

const handleFinalSubmit = async (values, resetForm) => {
  const valid = validateContactPersonForm();
  if (!valid) return;

  const res = await submitMembership({
    ...values,
    contactPersonList: memberlist, // 🔥 IMPORTANT
  });

  if (res) {
    // resetForm();
    showAlert("Membership updated successfully", "", msgTypes.success, msgTypes.OK_KEY);
    setActiveStep(5);
    // setActiveStep(0); // optional
  }
};



  return (
    <>
      <div className='mt-3'>
        <div className='row'>
          <div className='col-lg-4 work'>
            <div className='stepper-body'>
              <Stepper
                activeStep={activeStep}
                orientation={'vertical'}
                sx={{
                  width: '100%',
                  backgroundColor: 'transparent',
                  marginBottom: '30px',
                }}
              >
                {[
                  'Company Details',
                  'Company Address',
                  'Company Description',
                  'Company Social Profiles',
                  'Membership Type',
                  'Contact Person',
                ].map((label, index) => (
                  <Step key={index}>
                    <StepLabel className="step-label-sec"
                      sx={{
                        '& .MuiStepLabel-label': {
                        }
                      }}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </div>
          </div>
          <div className='col-lg-8'>
            <div className='card border-0 h-100 dash-one'>
              <div className='card-body h-100'>
                <Box className="main-box h-100 detail-section" width="80%" margin="0 auto" padding="20px" marginBottom='60px'>
                  <Grid container justifyContent="left">
                    <Paper
                      className="event-paper mb-0 h-100"
                      style={{
                        marginBottom: '20px',
                        backgroundColor: '#ffffff'
                      }}
                    >
                      <Formik
                        enableReinitialize={true}
                        initialValues={initialValues}
                        validationSchema={validation[activeStep]}
                        onSubmit={async (values, { resetForm }) => {
                     
                      setActiveStep(prev => prev + 1);

                          const valid = validateContactPersonForm();
                          if (valid) {
                            const res = await submitMembership(values);
                            if (res) {
                              resetForm();
                            }
                          }
                        }}
                        innerRef={formikRef}

                      >
                        {({ handleSubmit, isSubmitting, setFieldValue, isValid, dirty, values }) => (
                          <Form className='h-100' onSubmit={handleSubmit}>

                            {activeStep === 0 && (
                              <>
                                <div className='member-block-body h-100 d-flex flex-column justify-content-between'>
                                  <div className='row'>
                                    <div className='col-12'>
                                      <Typography variant="h1" align="center" marginBottom="30px">
                                        Company Details
                                      </Typography>
                                    </div>
                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="textfield"
                                        name="companyName"
                                        label="Company Name"
                                        placeholder="Enter Your Company Name"
                                        requiredField
                                        disabled={disabledField}
                                      />
                                    </div>
                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="textfield"
                                        name="companyEmail"
                                        label="Company Email"
                                        placeholder="Enter Your Company Email"
                                        requiredField
                                      />
                                    </div>

                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="phoneInputField"
                                        name="primaryPhoneNumber"
                                        label="Mobile Number"
                                        placeholder="Enter Your Mobile Number"
                                        requiredField
                                      />
                                    </div>

                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="phoneInputField"
                                        name="secondaryPhoneNumber"
                                        label="Alternative Mobile Number"
                                        placeholder="Alternate Mobile Number"
                                      />
                                    </div>
                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="textfield"
                                        name="accountingEmail"
                                        label="Accounting Email"
                                        placeholder="Enter Your Accounting Email"
                                      />
                                    </div>
                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="uploadImage"
                                        name="companyLogoFile"
                                        nameUrl="companyLogo"
                                        label="Company Logo"
                                        tooltip={[msgTypes.DOCUMENT_TYPE.JPG, msgTypes.DOCUMENT_TYPE.JPEG,
                                        msgTypes.DOCUMENT_TYPE.PNG, msgTypes.FILE_SIZE_ALLOW_3MB]}
                                      />
                                      <p className='error-msg-img'>Image dimensions 250x100px & upto 100kb.</p>
                                    </div>

                                  </div>
                                  <Box marginTop="20px" display="flex" justifyContent="end">
                                    <FormikControl control='button' className="btn-cancel btn mx-2" color="warning" label="Back" type="reset"
                                      //  onClick={() => navigate(-1)} 
                                      onClick={() => { setFlag(false) }}

                                    />

                                    <Button
                                      onClick={handleNext}
                                      variant="contained"
                                      className='btn btn-submit'
                                      color="primary"
                                      disabled={!(isValid) || addBranch && !dirty}
                                    // disabled={!(isValid) || (!dirty && !addBranch)}
                                    >
                                      Next
                                    </Button>

                                  </Box>
                                </div>
                              </>
                            )}
                            {activeStep === 1 && (
                              <>
                                {/* <div className='container'> */}
                                <div className='member-block-body d-flex flex-column justify-content-between'>
                                  {(addBranch === true || (memberDetails.isHeadOffice === false && memberDetails.companyId !== '') || updateRecord.isHeadOffice === false) ? (
                                    <Typography variant="h1" align="left">
                                      Branch Office Address
                                    </Typography>
                                  ) : (
                                    <Typography variant="h1" align="left">
                                      Head Office Address
                                    </Typography>
                                  )}

                                  <div className='row'>
                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="textfield"
                                        name="addressLine1"
                                        label="Address Line 1"
                                        placeholder="Enter Your Address"
                                        disabled={disabledField}
                                      // requiredField
                                      />
                                    </div>

                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="textfield"
                                        name="addressLine2"
                                        label="Address Line 2"
                                        placeholder="Enter Your Address"
                                        disabled={disabledField}
                                      // requiredField
                                      />
                                    </div>

                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl control='autocomplete'
                                        label="Country"
                                        name="countryId"
                                        placeholder="Select Country"
                                        requiredField={true}
                                        options={countryList}
                                        onChange={(e) => { loadStateList(e.countryIdentifier) }}
                                        keyfield="name"
                                        valuefield="countryIdentifier"
                                        disabled={disabledField}
                                      />
                                    </div>
                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl control='autocomplete'
                                        label="State"
                                        name="stateId"
                                        placeholder="Select State"
                                        onChange={(e) => { loadCityList(e.stateIdentifier) }}
                                        // requiredField={true}
                                        options={stateList}
                                        keyfield="name"
                                        valuefield="stateIdentifier"
                                        disabled={disabledField}
                                      />
                                    </div>
                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl control='autocomplete'
                                        label="City"
                                        name="cityId"
                                        placeholder="Select City"
                                        // requiredField={true}
                                        options={cityList}
                                        keyfield="name"
                                        valuefield="cityIdentifier"
                                        disabled={disabledField}
                                      />
                                    </div>
                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="textfield"
                                        name="zipCode"
                                        label="Zip Code"
                                        placeholder="Enter Your Company Zip Code"
                                        requiredField
                                        disabled={disabledField}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <Box marginTop="20px" display="flex" justifyContent="space-between">
                                  <Button
                                    className='back-btn btn btn-back'
                                    variant="contained"
                                    color="primary"
                                    onClick={handleBack}
                                  // onClick={() => { setFlag(false) }}
                                  >
                                    Back
                                  </Button>
                                  <Button
                                    onClick={handleNext}
                                    variant="contained"
                                    color="primary"
                                    className='btn btn-submit'
                                    disabled={!isValid || values.countryId === 0 || values.countryId === null}
                                  >
                                    Next
                                  </Button>
                                </Box>

                              </>
                            )}
                            {activeStep === 2 && (
                              <>
                                <div className='member-block-body h-100 d-flex flex-column justify-content-between'>
                                  <Typography variant="h1" align="left" marginBottom="30px">
                                    Company Description
                                  </Typography>
                                  <Grid className="text-area position-relative" item xs={12}>
                                    {/* <FormikControl
                                      control="textfield"
                                      label="Company Details"
                                      type="text"
                                      variant="outlined"
                                      requiredField
                                      multiline
                                      rows={4}
                                      fullWidth
                                      sx={{ m: 1 }}
                                      name="companyDetails"
                                      placeholder="Company Details"
                                    /> */}
                                    <ReactQuill
                                      value={values.companyDetails}
                                      onChange={(content) => {
                                        setFieldValue("companyDetails", content);
                                        formikRef.current?.setFieldTouched("companyDetails", true, true); // ✅ important
                                      }}
                                      placeholder="Enter company description"
                                      theme="snow"
                                      style={{ minHeight: "200px" }}
                                    />

                                  </Grid>

                                  <Grid className="text-area" item xs={12}>
                                    <InputLabel
                                      variant="standard"
                                      sx={{ textAlign: "left", fontWeight: "500", color: "#000000" }}>
                                      Company Services
                                    </InputLabel>
                                    <div role="group" aria-labelledby="checkbox-group" className='m-2 services-membership-sec'>
                                      {companyServiceList.map(data => {
                                        return (
                                          <div className='services-sec'>
                                            <label><Field type="checkbox" name="companyServices" value={"" + data.serviceId} />&nbsp;&nbsp;{data.serviceName}</label>
                                          </div>
                                        )
                                      })}
                                    </div>
                                  </Grid>



                                  <Box marginTop="20px" display="flex" justifyContent="space-between">
                                    <Button
                                      className='btn btn-cancel'
                                      variant="contained"
                                      color="primary"
                                      onClick={handleBack}
                                    >
                                      Back
                                    </Button>
                                    <Button

                                      onClick={handleNext}
                                      className='btn btn-submit'
                                      variant="contained"
                                      color="primary"
                                      // disabled={!(isValid) || values?.companyDetails?.length === 0}
                                      disabled={!isValid || (addBranch && !dirty)}


                                    >
                                      Next
                                    </Button>
                                  </Box>
                                </div>
                              </>
                            )}
                            {activeStep === 3 && (
                              <>
                                <div className='member-block-body h-100 d-flex flex-column justify-content-between'>
                                  <div className='row'>
                                    <div className='col-12'>
                                      <Typography variant="h1" align="left" marginBottom="30px">
                                        Company Social Profiles
                                      </Typography>
                                    </div>
                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="textfield"
                                        name="instagramUrl"
                                        label="Instagram URL"
                                        placeholder="Enter Your Instagram URL"
                                      />
                                    </div>
                                    <div className='col-lg-6 position-relative'>
                                      <FormikControl
                                        control="textfield"
                                        name="linkedinUrl"
                                        label="LinkedIn URL"
                                        placeholder="Enter Your LinkedIn URL"
                                      />
                                    </div>
                                    <div className='col-lg-6'>
                                      <FormikControl
                                        control="textfield"
                                        name="twitterUrl"
                                        label="Twitter URL"
                                        placeholder="Enter Your Twitter URL"
                                      />
                                    </div>
                                    <div className='col-lg-6'>
                                      <FormikControl
                                        control="textfield"
                                        name="facebookUrl"
                                        label="Facebook URL"
                                        placeholder="Enter Your Facebook URL"
                                      />
                                    </div>
                                    <div className='col-lg-6'>
                                      <FormikControl
                                        control="textfield"
                                        name="youtubeUrl"
                                        label="YouTube URL"
                                        placeholder="Enter Your YouTube URL"
                                      />
                                    </div>
                                  </div>

                                  <Box marginTop="20px" display="flex" justifyContent="space-between">
                                    <Button
                                      className='btn btn-cancel'
                                      variant="contained"
                                      onClick={handleBack}
                                    // onClick={() => { setFlag(false) }}
                                    >
                                      Back
                                    </Button>
                                    <Button
                                      onClick={handleNext}
                                      variant="contained"
                                      className='btn btn-submit'
                                      color="primary"
                                      disabled={!(isValid)}
                                    >
                                      Next
                                    </Button>
                                  </Box>
                                </div>
                              </>
                            )}
                            {activeStep === 4 && (
                              <>
                               {/* 🔑 UPDATE CASE FIX: backend value → radio value */}
                                  {values.membershipType === "FOUNDER" &&
                                    setFieldValue("membershipType", "founder", false)}

                                  {values.membershipType === "EXCLUSIVE" &&
                                    setFieldValue("membershipType", "exclusive", false)}
                                <div className='member-block-body h-100 d-flex flex-column justify-content-between'>
                                  <div className='row position-relative'>
                                    <Typography variant="h1" align="left" marginBottom="30px">
                                      Membership Type
                                    </Typography>
                                     <FormikControl
                                        className="radiobutton"
                                        control="radiogroup"
                                        label="Membership Type"
                                        name="membershipType"
                                        options={[
                                          { key: "Founder Member", value: "founder" },
                                          { key: "Exclusive Member", value: "exclusive" },
                                        ]}
                                        placeholder="Select Membership Type"
                                        requiredField
                                        row
                                        disabled={disabledField}
                                      />
                                  </div>
                                  <Box className="member-btn-one" marginTop="20px" display="flex" justifyContent="space-between">
                                    <Button
                                      className='btn btn-cancel'
                                      variant="contained"
                                      color="primary"
                                      onClick={handleBack}
                                    // onClick={() => { setFlag(false) }}
                                    >
                                      Back
                                    </Button>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      className='btn btn-submit'
                                      onClick={handleNext}
                                      disabled={(!(isValid)) || values?.membershipType?.length === 0}
                                    >
                                      Next
                                    </Button>
                                  </Box>
                                </div>
                              </>
                            )}
                            {activeStep === 5 && (
                              <>
                                <div className='collll'>
                                  <MembershipContactPerson
                                    memberlist={memberlist}
                                    setMemberList={(updater) => {
                                      setMemberList(prev => {
                                        const newList =
                                          typeof updater === "function" ? updater(prev) : updater;

                                        // 🔑 Formik ko hamesha ARRAY hi mile
                                        formikRef.current?.setFieldValue("contactPerson", newList, false);

                                        return newList;
                                      });
                                    }}
                                  />
                                  {memberlist?.length > 0 ?
                                    <>
                                      <RECAPTCHA
                                        sitekey={window.location.href.includes(msgTypes.LOCALHOST) ? msgTypes.GOOGLE_CAPTCHA_SITE_KEY_LOCAL : msgTypes.GOOGLE_CAPTCHA_SITE_KEY_PROD}
                                        ref={recaptcha}
                                        onChange={onCaptchaSubmit}
                                        className='recaptcha-obj'
                                      />

                                      <Box className="btn-member" marginTop="20px" display="flex" justifyContent="space-between">
                                        <Button
                                          className='btn btn-cancel'
                                          variant="contained"
                                          color="primary"
                                          onClick={handleBack}
                                        >
                                          Back
                                        </Button>
                                        {/* <Button

                                          type="submit"
                                          variant="contained"
                                          className='btn btn-submit'
                                          color="primary"
                                          disabled={isSubmitting && (!(isValid) || memberlist?.length === 0) || !captchaMatched}
                                        >
                                          Submit
                                        </Button> */}
                                        <Button
                                            type="button" // ⚠️ Must be type button, not submit
                                            // onClick={handleFinalSubmit}
                                            variant="contained"
                                            className='btn btn-submit'
                                            color="primary"
                                           disabled={!captchaMatched || memberlist.length === 0 || isSubmitting}
  onClick={() => handleFinalSubmit(values, formikRef.current?.resetForm)}
                                          >
                                            Submit
                                          </Button>

                                      </Box>
                                    </>

                                    : ""}
                                </div>
                              </>
                            )}
                          </Form>
                        )}
                      </Formik>
                    </Paper>
                  </Grid>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default UpdateRegisteredMember;
